import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSignedUp.meta';

export type UseTrackSignedUpParams = {
  account_type: 'full' | 'anonymous';
  auth_method: 'email' | 'google' | 'apple' | 'saml';
  context: 'fresh_signup' | 'join_from_invite' | 'share_link' | 'canva';
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  workspace_id?: string;
  workspace_name?: string;
};

export const SIGNED_UP_AUTH_METHOD_MAP: Record<string, UseTrackSignedUpParams['auth_method']> = {
  Apple: 'apple',
  Cognito: 'email',
  Google: 'google',
  SAML: 'saml',
};

export const SIGNED_UP_CONTEXT_MAP: Record<string, UseTrackSignedUpParams['context']> = {
  canva: 'canva',
  main: 'fresh_signup',
  'share-link': 'share_link',
  'workspace-invite': 'join_from_invite',
};

export const useTrackSignedUp = () => {
  const { track } = useAnalyticsUtilities();

  const trackSignedUp = useCallback(
    (params: UseTrackSignedUpParams) => {
      track(META.name, params);
    },
    [track],
  );

  return {
    trackSignedUp,
  };
};
